import { Link, Outlet, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import "../../../App/App.css";
import "../../../assets/style.css";
import { logout } from "../../../lib/services/authService";
import { useNavigate } from "react-router-dom";
import { resetAllStores } from "../../../lib/stores";
import { useEvent } from "../../../lib/hooks/useEvent";

const Navbar = ({
  isAdminAuthenticated,
  setIsAdminAuthenticated,
  location,
}) => {
  const navigate = useNavigate();
  const loc = useLocation();

  //If volunteer path, 
  if (loc.pathname.startsWith("/volunteer")) {
    return (
      <main>
        <Outlet />
      </main>
    );
  }

  const NavbarPreLogin = () => {
    return (
      <>
        <nav
          className="navbar fixed-top"
          style={{ backgroundColor: "#ed4709" }}
        >
          <div>
            <Link to="/admin/stencil-selection" className="brand p-3">
              Pumpkin Tracker
            </Link>
          </div>
        </nav>
      </>
    );
  };

  const NavbarPostLogin = ({
    isAdminAuthenticated,
    setIsAdminAuthenticated,
  }) => {
    const { event } = useEvent();

    const endSession = async () => {
      if (isAdminAuthenticated) {
        if (window.confirm("Are you sure you want to logout?")) {
          const response = await logout();
          if (response.ok) {
            setIsAdminAuthenticated(false);
            localStorage.clear();
            sessionStorage.clear();
            resetAllStores();
            navigate("/admin/login");
          } else {
            alert("Failed to logout");
          }
        }
      }
    };

    return (
      <div style={{ maxHeight: "75px" }}>
        <nav
          className="navbar fixed-top"
          style={{
            backgroundColor: "#ed4709",
            minHeight: "60px",
            padding: "1rem",
          }}
        >
          <div>
            <Link
              to="/admin/stencil-selection"
              className="d-flex justify-start brand px-3"
            >
              Pumpkin Tracker
            </Link>
          </div>
          {/** TODO: when authentication is set up, only make this visible after login */}
          <div className="d-flex gap-3 justify-end">
            <Link
              to="/admin/event-management"
              className="nav-element"
              style={{
                fontWeight: `${
                  location === "/admin/event-management" ? "bold" : "none"
                }`,
              }}
            >
              Event Management
            </Link>
            <Link
              to="/admin/stencil-selection"
              className="nav-element"
              style={{
                fontWeight: `${
                  location === "/admin/stencil-selection" ? "bold" : "none"
                }`,
              }}
            >
              Stencil Selection
            </Link>
            {!!event.isActive ? (
              <Link
                to="/admin/stencil-management"
                className="nav-element"
                style={{
                  fontWeight: `${
                    location === "/admin/stencil-management" ? "bold" : "none"
                  }`,
                }}
              >
                Stencil Management
              </Link>
            ) : (
              <span className="nav-element" style={{color: "#d1d1d1"}}>Stencil Management</span>
            )}
            <Link
              to="/admin/login"
              className="nav-element"
              style={{ paddingRight: "5px" }}
              onClick={endSession}
            >
              Logout
            </Link>
          </div>
        </nav>
      </div>
    );
  };

  return (
    <>
      {isAdminAuthenticated ? (
        <NavbarPostLogin
          setIsAdminAuthenticated={setIsAdminAuthenticated}
          isAdminAuthenticated={isAdminAuthenticated}
        />
      ) : (
        <NavbarPreLogin />
      )}
      <main>
        <Outlet />
      </main>
    </>
  );
};

export default Navbar;
